import {useAtom} from 'jotai';
import persistentAtom from 'shared/atoms/persistent-atom';

const openedOrderStatusAtom = persistentAtom<string[]>('openedOrderStatus', []);

const useOpenedOrderStatus = () => {
  const [openedOrderStatus, setOpenedOrderStatus] = useAtom<string[]>(
    openedOrderStatusAtom,
  );

  return {
    openedOrderStatus,
    setOpenedOrderStatus: setOpenedOrderStatus as (data: string[]) => void,
  };
};

export default useOpenedOrderStatus;
